export default __webpack_public_path__ + "static/media/2.f0a9f5a0.png";